<template>
  <div class="table-responsive mt-3 mb-0">
    <!-- Calendar -->
    <table class="table table-bordered custom-table mb-0">
      <thead class="thead-light header-date">
        <tr>
          <th class="time-td"></th>
          <th v-for="(item, i) in data" :key="i">{{ item.DateDisplay }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="time-td">12am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'12am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">1am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'1am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">2am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'2am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">3am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'3am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">4am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'4am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">5am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'5am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">6am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'6am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">7am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'7am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">8am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'8am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">9am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'9am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">10am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'10am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">11am</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'11am' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">12pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'12pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">1pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'1pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">2pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'2pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">3pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'3pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">4pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'4pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">5pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'5pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">6pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'6pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">7pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'7pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">8pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'8pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">9pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'9pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">10pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'10pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
        <tr>
          <td class="time-td">11pm</td>
          <td
            v-for="(item, i) in data"
            class="content-td"
            :key="'11pm' + i"
            @click.right="showAddMenu($event)"
          ></td>
        </tr>
      </tbody>
    </table>
    <!-- /Calendar -->

    <!-- Events -->
    <template v-for="item in data">
      <div
        v-for="rec in item.Classes"
        :key="rec.Id"
        :id="`event${rec.Id}`"
        class="event-div border-gray"
        :style="`background-color:${rec.Color}`"
        @click="showEvent(rec, $event)"
      >
        <template v-if="!rec.IsPublicHoliday">
          <span class="time-span">{{ rec.ClassTime }}</span>
          <br />
        </template>
        <template v-if="!rec.IsPublicHoliday && isMainAdmin">
          <span class="school-span">{{ rec.School }}</span>
          <br />
        </template>
        <span class="event-span">
          {{ rec.EventName }}
          {{ !rec.IsPublicHoliday ? `(${rec.Duration})` : "" }}
        </span>
      </div>
    </template>
    <!-- /Events -->

    <!-- Add Menu Right Click -->
    <div
      tabindex="-1"
      class="card m-0 menu"
      id="addMenu"
      ref="addMenu"
      :style="`top:${top};left:${left};display:none`"
      @blur="closeAddMenu"
    >
      <div class="card-body p-0">
        <div @click="newClassBooking" class="menu-item">
          <i class="fa fa-plus-circle mr-1"></i>New Class Booking
        </div>
      </div>
    </div>
    <!-- /Add Menu Right Click -->
  </div>
</template>
  
  <script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import $ from "jquery";
export default {
  props: [
    "selectedDate",
    "selectedCountries",
    "schoolId",
    "subjectName",
    "subjectLevelName",
    "duration",
    "makeupClass",
    "studentName",
    "instructorName",
    "startDate",
    "endDate",
    "statuses",
    "instructorId",
    "studentId",
    "startTimeHour",
    "startTimeMinute",
    "startTimePart",
    "endTimeHour",
    "endTimeMinute",
    "endTimePart",
  ],
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      data: [],
      //for right click menu
      top: "0px",
      left: "0px",
      scrollTop: 0,
    };
  },
  watch: {
    "$store.state.expandSidebar": function (val) {
      window.setTimeout(() => {
        this.loadCalendar(this.data);
      }, 300);
    },
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    isMainAdmin() {
      return this.tokenObj.UserType == this.userTypeMainAdmin;
    },
    isSchoolAdmin() {
      return (
        this.tokenObj.UserType == this.userTypeSchoolAdmin ||
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin &&
          this.$route.path.includes("/schooladmin/"))
      );
    },
    isInstructor() {
      return (
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin ||
          this.tokenObj.UserType == this.userTypeInstructor) &&
        this.$route.path.includes("/instructor/") &&
        !this.$route.path.includes("/schooladmin/")
      );
    },
  },
  methods: {
    showEvent(payload, event) {
      event.preventDefault();
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      if (payload.IsPublicHoliday) {
        let obj = {
          eventName: payload.EventName,
          date: payload.DateDisplay,
          country: payload.Country,
        };
        this.$emit("showPublicHoliday", obj);
      } else {
        let obj = {
          classBookingId: payload.ClassId,
          eventName: payload.EventName,
          duration: payload.Duration,
          school: payload.School,
          student: payload.Student,
          instructor: payload.Instructor,
          date: payload.DateDisplay,
          dateCal: payload.DateCal,
          time: payload.ClassTime,
          makeupClass: payload.MakeupClass,
          location: payload.Location,
          fee: payload.ClassFee,
          status: payload.Status,
          color: payload.Color,
          canChangeToPending: payload.CanChangeToPending,
        };
        this.$emit("showClass", obj);
      }
    },
    updateCalendar() {
      window.setTimeout(() => {
        if (this.data && this.data.length) {
          this.loadCalendar(this.data);
        }
      }, 300);
    },
    updateScrollTop() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
    },
    showAddMenu(event) {
      event.preventDefault();
      if (this.isMainAdmin || this.isSchoolAdmin || this.isInstructor) {
        this.$nextTick(() => {
          $(document).scrollTop(this.scrollTop);
        });
        $("#addMenu").show();
        this.$refs.addMenu.focus();
        let calDivOuterHeight = $(".cal-div").outerHeight();
        let calDivOuterWidth = $(".cal-div").outerWidth();
        if (calDivOuterHeight >= 300) {
          calDivOuterHeight = 0;
        } else {
          calDivOuterHeight = calDivOuterHeight + 20;
          calDivOuterWidth = 0;
        }

        let headerHeight = $(".header").outerHeight();
        let contentPaddingTop = 30;
        let pageHeaderHeight = $(".page-header").outerHeight();
        let pageHeaderMarginBottom = 30;
        let rowFilter1Height = $(".row-filter-1").length
          ? $(".row-filter-1").outerHeight()
          : 0;
        let rowFilter2Height = $(".row-filter-2").length
          ? $(".row-filter-2").outerHeight()
          : 0;
        let rowFilter3Height = $(".row-filter-3").length
          ? $(".row-filter-3").outerHeight()
          : 0;
        let rowFilter4Height = $(".row-filter-4").length
          ? $(".row-filter-4").outerHeight()
          : 0;
        let rowFilter5Height = $(".row-filter-5").length
          ? $(".row-filter-5").outerHeight()
          : 0;
        let extraMargin = !this.isMainAdmin ? 15 : 0;
        let navigationDivHeight = $(".navigation-div").outerHeight();
        let allAboveElementsHeight =
          headerHeight +
          contentPaddingTop +
          pageHeaderHeight +
          pageHeaderMarginBottom +
          rowFilter1Height +
          rowFilter2Height +
          rowFilter3Height +
          rowFilter4Height +
          rowFilter5Height +
          8 +
          20 +
          navigationDivHeight +
          16 +
          calDivOuterHeight +
          extraMargin;
        let top = event.y + this.scrollTop - allAboveElementsHeight;

        let sideBarOuterWidth = $(".sidebar").outerWidth();
        let allLeftElementsWidth = sideBarOuterWidth + 30 + calDivOuterWidth;
        let addMenuOuterWidth = $(".menu").outerWidth();
        let timeTdOuterWidth = $(".time-td").outerWidth();
        let contentTdOuterWidth = $(".content-td").outerWidth() * 7;
        let left = event.x - allLeftElementsWidth;
        if (
          left >=
          timeTdOuterWidth + contentTdOuterWidth - addMenuOuterWidth
        ) {
          left = left - (addMenuOuterWidth + 5);
        }
        this.top = top + "px";
        this.left = left + "px";
      }
    },
    closeAddMenu() {
      $("#addMenu").hide();
    },
    newClassBooking() {
      let routerName = "";
      if (this.isMainAdmin) routerName = "mainAdminClassBookingAdd";
      else if (this.isSchoolAdmin) routerName = "schoolAdminClassBookingAdd";
      else if (this.isInstructor) routerName = "instructorClassBookingAdd";
      this.$router.push({ name: routerName });
    },
    //main function
    getClassBookingListByWeek() {
      let param = {
        Token: this.tokenObj.Token,
        SchoolId: this.schoolId,
        SubjectName: this.subjectName,
        SubjectLevelName: this.subjectLevelName,
        Duration: this.duration,
        Frequency: this.frequency,
        LocationId: this.locationId,
        StartDate: this.startDate,
        EndDate: this.endDate,
        StartTimeHour: this.startTimeHour,
        StartTimeMinute: this.startTimeMinute,
        StartTimePart: this.startTimePart,
        EndTimeHour: this.endTimeHour,
        EndTimeMinute: this.endTimeMinute,
        EndTimePart: this.endTimePart,
        Availability: this.availability,
        InstructorId: this.instructorId,
        InstructorName: this.instructorName,
        Date: this.selectedDate,
        SelectedCountries: this.selectedCountries,
      };
      this.$store.state.isLoading = true;
      API.classBooking
        .getClassBookingListByWeek(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.data = response.data.data;
            this.$nextTick(() => {
              this.loadCalendar(this.data);
            });
            window.setTimeout(() => {
              this.loadCalendar(this.data);
            }, 100);
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    loadCalendar(data) {
      for (let index = 0; index < data.length; index++) {
        let classes = data[index].Classes;
        if (!classes || !classes.length) continue;
        //adjust width and left
        let timeTdOuterWidth = $(".time-td").outerWidth();
        let contentTdOuterWidth = $(".content-td").outerWidth();
        let additionalContentTdWidth = contentTdOuterWidth * index;
        let alreadyCheckedIndex = [];
        for (let i = 0; i < classes.length; i++) {
          if (alreadyCheckedIndex.includes(i)) continue;
          let minTotalStartTimeMinutes = classes[i].TotalStartTimeMinutes;
          let maxTotalEndTimeMinutes = classes[i].TotalEndTimeMinutes;
          let overlapEvents = [];
          overlapEvents.push(classes[i]);
          alreadyCheckedIndex.push(i);
          for (let j = 0; j < classes.length; j++) {
            if (i == j || alreadyCheckedIndex.includes(j)) continue;
            let totalStartTimeMinutes = classes[j].TotalStartTimeMinutes;
            let totalEndTimeMinutes = classes[j].TotalEndTimeMinutes;
            if (
              totalStartTimeMinutes >= minTotalStartTimeMinutes &&
              totalStartTimeMinutes < maxTotalEndTimeMinutes
            ) {
              overlapEvents.push(classes[j]);
              alreadyCheckedIndex.push(j);
              if (totalEndTimeMinutes > maxTotalEndTimeMinutes) {
                maxTotalEndTimeMinutes = totalEndTimeMinutes;
              }
            }
          }

          if (!overlapEvents.length) continue;
          let eachElemWidth = contentTdOuterWidth / overlapEvents.length;
          this.$nextTick(() => {
            for (let x = 0; x < overlapEvents.length; x++) {
              let width = eachElemWidth;
              if (overlapEvents[x].IsPublicHoliday) width = width + 1;
              $(`#event${overlapEvents[x].Id}`).outerWidth(`${width}px`);
              let left =
                timeTdOuterWidth + additionalContentTdWidth + x * eachElemWidth;
              $(`#event${overlapEvents[x].Id}`).css("left", `${left}px`);
            }
          });
        }
        //adjust height and top
        let headerDateOuterHeight = $(".header-date").outerHeight();
        this.$nextTick(() => {
          for (let item of classes) {
            let duration =
              item.TotalEndTimeMinutes - item.TotalStartTimeMinutes;
            $(`#event${item.Id}`).outerHeight(`${duration}px`);
            $(`#event${item.Id}`).css(
              "top",
              `${item.TotalStartTimeMinutes + headerDateOuterHeight}px`
            );
          }
        });
      }
    },
  },
  created() {
    this.getClassBookingListByWeek();
  },
  mounted() {
    this.updateScrollTop();
    window.addEventListener("scroll", this.updateScrollTop);
    window.addEventListener("resize", this.updateCalendar);
    //scroll to next available event
    window.setTimeout(() => {
      let earliestClass = { Id: "", TotalStartTimeMinutes: 9999 };
      if (this.data && this.data.length) {
        for (let item of this.data) {
          if (
            item.Classes &&
            item.Classes.length &&
            item.Classes[0].TotalStartTimeMinutes <
              earliestClass.TotalStartTimeMinutes
          ) {
            earliestClass = item.Classes[0];
          }
        }
        if (earliestClass.Id) {
          this.$nextTick(() => {
            if ($(`#event${earliestClass.Id}`))
              $(document).scrollTop(
                $(`#event${earliestClass.Id}`).position().top
              );
          });
        }
      }
    }, 300);
    //adjust word-spacing
    let userAgent = navigator.userAgent;
    let platform = navigator.userAgentData.platform || navigator.platform;
    let isWindow = /Win/i.test(platform);
    let isAndroid = /Android/i.test(userAgent);
    let isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    let isMacos = /Mac/i.test(platform);
    if (isWindow || isAndroid || (isMacos && !isSafari)) {
      $(".table thead th").css("word-spacing", "-5px");
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateScrollTop);
    window.removeEventListener("resize", this.updateCalendar);
  },
};
</script>
  
  <style scoped>
.table-responsive {
  position: relative;
}
table {
  table-layout: fixed;
}
.table thead th {
  letter-spacing: -0.5px;
  font-size: 13px;
  text-align: center;
}
.table.custom-table > thead > tr > th.time-td {
  width: 45px;
}
.table.custom-table > thead > tr > th {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.table.custom-table > tbody > tr > td.time-td {
  color: #495057;
  background-color: #e9ecef;
  vertical-align: top !important;
  padding-top: 1px !important;
  padding-right: 3px !important;
  text-align: right !important;
  height: 60px;
  width: 45px;
  font-size: 13px;
}
.table.custom-table > tbody > tr > td {
  padding: 0 !important;
  height: 60px;
}
.table.custom-table > tbody > tr > td.content-td {
  cursor: pointer;
}

.event-div {
  position: absolute;
  color: white;
  padding: 2px;
  line-height: 10px;
  overflow: auto;
  cursor: pointer;
}
.time-span {
  letter-spacing: -0.5px;
  font-size: 9px;
}
.event-span,
.school-span {
  font-size: 10px;
}
.menu {
  max-width: fit-content;
  border: 1px solid lightgrey;
  background: #fafafa;
  display: block;
  position: absolute;
  z-index: 99;
  font-size: 11px;
}
.menu-item {
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 1px;
  cursor: pointer;
}
.menu-item:hover {
  background: #d0d0d0;
}
.border-gray {
  border: 1px solid #dee2e6;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassBookingCalendarFormatWeek.vue